<section class="seller-container">
  <form [formGroup]="formStepTwo" autocomplete="off">
    <section class="ids-mv-4">
      <section class="ids-pt-4">
        <h2 class="ids-text-title-01">dados do cônjuge ou companheiro</h2>

        <section class="ids-row ids-pt-4">
          <ids-form-field
            class="ids-col-6"
            label="nome completo"
            [errorMessage]="getTextFieldError('partner_name', 'o nome completo')"
          >
            <input idsInput autofocus formControlName="partner_name"/>
          </ids-form-field>

          <ids-form-field class="ids-col-6" label="CPF" [errorMessage]="getErrorInvalid('CPF')">
            <input idsInput idsMask="999.999.999-99" formControlName="partner_cpf" type="numeric"/>
          </ids-form-field>

          <ids-form-field
            class="ids-col-6"
            label="data de nascimento"
            [errorMessage]="getDateFieldError('partner_birth_date', 'a data de nascimento')"
          >
            <input
              idsDatepicker
              formControlName="partner_birth_date"
            />
          </ids-form-field>

          <ids-form-field
            class="ids-col-6 "
            label="nacionalidade"
            [errorMessage]="getForgotFill('a nacionalidade')"
          >
            <ids-select formControlName="partner_birth_nationality" required>
              <ids-option
                *ngFor="let option of listNacionalites"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            class="ids-col-6 "
            label="UF de nascimento"
            [errorMessage]="getForgotFill('a UF de nascimento')"
          >
            <ids-select formControlName="partner_birth_state" required>
              <ids-option
                *ngFor="let option of listStates"
                [value]="option.uf"
              >
                {{ option.uf }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ng-container
            *ngIf="formStepTwo.get('partner_birth_nationality')?.value.toLocaleLowerCase() === 'brasileira';else elseCity">
            <ids-shimmer class="ids-col-6" [show]="loadingCities">
              <ids-form-field
                *ngIf="!loadingCities"
                label="cidade de nascimento"
                [errorMessage]="getErrorMandatory('cidade de nascimento')">
                <ids-select formControlName="partner_birth_city">
                  <ids-option *ngFor="let option of listCities" [value]="option.name">
                    {{ option.name }}
                  </ids-option>
                </ids-select>
              </ids-form-field>
            </ids-shimmer>
          </ng-container>

          <ng-template #elseCity>
            <ids-form-field
              class="ids-col-6"
              label="cidade de nascimento"
              [errorMessage]="getForgotFill('a cidade de nascimento')">
              <input idsInput formControlName="partner_birth_city"/>
            </ids-form-field>
          </ng-template>

          <ids-form-field
            class="ids-col-6 ids-pt-2"
            label="gênero"
            [errorMessage]="getForgotFill('o gênero')"
          >
            <ids-select formControlName="partner_gender" required>
              <ids-option
                *ngFor="let option of listaSexo"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <app-domain-input-select
            class="ids-col-6"
            label="profissão ou principal ocupação"
            [errorMessage]="getForgotFill('a profissão ou principal ocupação')"
            [formParent]="formStepTwo"
            formControlName="partner_profession"
            (formParentChange)="formStepTwo = $event"
            ngDefaultControl
          >
          </app-domain-input-select>
        </section>
      </section>

      <section class="ids-pt-10">
        <h3 class="ids-text-section-02">documento de identificação</h3>

        <section class="ids-row">
          <ids-form-field
            class="ids-col-6"
            label="tipo de documento"
            [errorMessage]="getForgotFill('o tipo de documento')"
          >
            <ids-select formControlName="partner_document_type" required>
              <ids-option
                *ngFor="let option of listaDocumentos"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            class="ids-col-6"
            label="número do documento"
            [errorMessage]="getForgotFill('o número do documento')"
          >
            <input
              idsInput
              type="text"
              [minlength]="docNumMinLen"
              [maxlength]="docNumMaxLen"
              formControlName="partner_document_number"
            />
          </ids-form-field>

          <ids-form-field
            class="ids-col-6"
            label="data de expedição"
            [errorMessage]="getDateFieldError('partner_document_issueDate', 'a data de expedição')"
          >
            <input
              idsDatepicker
              formControlName="partner_document_issueDate"
            />
          </ids-form-field>

          <ids-form-field
            class="ids-col-6"
            label="órgao expedidor"
            [errorMessage]="getForgotFill('o órgao expedidor')"
          >
            <ids-select formControlName="partner_document_issuingAuthority" required>
              <ids-option
                *ngFor="let option of listaOrgaoExpedidor"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field class="ids-col-6" label="UF" [errorMessage]="getForgotFill('a UF')">
            <ids-select formControlName="partner_document_issuingAuthorityState" required>
              <ids-option
                *ngFor="let option of listStates"
                [value]="option.uf"
              >
                {{ option.uf }}
              </ids-option>
            </ids-select>
          </ids-form-field>
        </section>
      </section>

      <section class="ids-pt-8">
        <h3 class="ids-text-section-02">filiação</h3>

        <section class="ids-row">
          <ids-form-field
            class="ids-col-6"
            label="Nome completo da mãe"
            [errorMessage]="getTextFieldError('partner_parentage_motherName', 'o nome completo da mãe')"
          >
            <input idsInput formControlName="partner_parentage_motherName" required/>
          </ids-form-field>

          <ids-form-field class="ids-col-6" label="Nome completo do pai (opcional)" [errorMessage]="getTextFieldError('partner_parentage_fatherName', 'o nome completo do pai')">
            <input idsInput formControlName="partner_parentage_fatherName"/>
          </ids-form-field>
        </section>
      </section>

      <section class="ids-pt-8">
        <h3 class="ids-text-section-02">contato</h3>

        <section class="ids-row">
          <ids-form-field
            class="ids-col-6"
            label="E-mail"
            [errorMessage]="getEmailFieldError('partner_contact_email', 'o e-mail')"
          >
            <input type="email" (blur)="normalizeEmail('partner_contact_email')" idsInput formControlName="partner_contact_email" required/>
          </ids-form-field>

          <ids-form-field
            class="ids-col-6"
            label="Celular ou telefone"
            [errorMessage]="getTextFieldError('partner_contact_phone','o celular ou telefone')"
          >
            <input
              idsInput
              [idsMask]="phoneMask"
              formControlName="partner_contact_phone"
              type="numeric"
              required
            />
          </ids-form-field>
        </section>
      </section>

      <section class="ids-pt-10">
        <app-cep-search
          [formParent]="formStepTwo"
          [formControlNames]="[
          'partner_address_zipCode',
          'partner_address_state',
          'partner_address_city',
          'partner_address_district',
          'partner_address_street',
          'partner_address_number',
          'partner_address_complement'
        ]"
          title="endereço residencial"
          ngDefaultControl
          (formParentChange)="formStepTwo = $event"
        >
        </app-cep-search>
      </section>

      <section class="ids-pt-10 ids-row">
        <h3 class="ids-text-section-02 ids-col-12">local de entrega de correspondência</h3>
        <section class="ids-col-12">
          <p class="ids-form ids-pt-2 ids-pv-4 ids-col-12">onde deseja receber correspondências?</p>
          <ids-form-selection-group inline>
            <ids-form-selection>
              <input
                type="radio"
                [value]="true"
                name="partner_deliveryAddress_isLocale"
                (click)="postLocationChange(true)"
                formControlName="partner_deliveryAddress_isLocale"
                idsRadioButton
              />
              <label>residência</label>
            </ids-form-selection>
            <ids-form-selection>
              <input
                type="radio"
                [value]="false"
                name="partner_deliveryAddress_isLocale"
                (click)="postLocationChange(false)"
                formControlName="partner_deliveryAddress_isLocale"
                idsRadioButton
              />
              <label>outro endereço</label>
            </ids-form-selection>
          </ids-form-selection-group>
        </section>
      </section>

      <section class="ids-pt-10" *ngIf="isOtherLocation()">
        <app-cep-search
          [formParent]="formStepTwo"
          [formControlNames]="[
          'partner_deliveryAddress_zipCode',
          'partner_deliveryAddress_state',
          'partner_deliveryAddress_city',
          'partner_deliveryAddress_district',
          'partner_deliveryAddress_street',
          'partner_deliveryAddress_number',
          'partner_deliveryAddress_complement'
        ]"
          title=""
          ngDefaultControl
          (formParentChange)="formStepTwo = $event"
        >
        </app-cep-search>
      </section>

      <section class="ids-pt-10 ids-row">
        <section class="ids-col-12">
          <article class="seller-tooltip">
            <h3 class="ids-text-section-02 ids-col-12">dados do procurador</h3>

          </article>
        </section>

        <section class="ids-col-12">
          <p class="ids-form ids-pt-2 ids-pv-4 ids-col-12">
            o côjunge ou convivente será representado por uma procuração?
          </p>
          <ids-form-selection-group inline>
            <ids-form-selection>
              <input
                type="radio"
                [value]="true"
                name="partner_attorneyData_useAttorney"
                (click)="procuratorChange(true)"
                formControlName="partner_attorneyData_useAttorney"
                idsRadioButton
              />
              <label>sim, será representado</label>
            </ids-form-selection>
            <ids-form-selection>
              <input
                type="radio"
                [value]="false"
                name="partner_attorneyData_useAttorney"
                (click)="procuratorChange(false)"
                formControlName="partner_attorneyData_useAttorney"
                idsRadioButton
              />
              <label>não será representado</label>
            </ids-form-selection>
          </ids-form-selection-group>
        </section>

        <section class="ids-col-12" *ngIf="isProxyData">
          <div class="ids-row">
            <ids-form-field
              class="ids-col-6"
              label="Nome completo do procurador"
              [errorMessage]="getTextFieldError('partner_attorneyData_fullName', 'o nome completo do procurador')"
            >
              <input type="text" idsInput formControlName="partner_attorneyData_fullName"/>
            </ids-form-field>
            <ids-form-field
              class="ids-col-6"
              label="CPF ou CNPJ"
              [errorMessage]="getErrorInvalid('CPF ou CNPJ')"
            >
              <input
                idsInput
                appUpperCaseInput
                [idsMask]="maskCpfCnpj"
                (change)="procuratorCpfChange()"
                formControlName="partner_attorneyData_documentNumber"
              />
            </ids-form-field>
          </div>
          <div class="ids-row">
            <ids-form-field
              class="ids-col-6"
              label="E-mail"
              [errorMessage]="getEmailFieldError('partner_attorneyData_email', 'o e-mail')"
            >
              <input idsInput (blur)="normalizeEmail('partner_attorneyData_email')" formControlName="partner_attorneyData_email"/>
            </ids-form-field>
            <ids-form-field
              class="ids-col-6"
              label="Celular ou telefone"
              [errorMessage]="getTextFieldError('partner_attorneyData_phone','o celular ou telefone')"
            >
              <input
                type="numeric"
                idsInput
                [idsMask]="phoneMask"
                formControlName="partner_attorneyData_phone"
              />
            </ids-form-field>
          </div>
        </section>
      </section>

      <section class="ids-pt-10 ids-row">
        <h3 class="ids-text-section-02 ids-col-12">informações complementares</h3>
        <section class="ids-col-12">
          <p class="ids-form ids-pt-2 ids-pv-4 ids-col-12">
            como pessoa física, você é empregador, trabalhador autônomo ou produtor rural e mantém
            funcionários registrados a seu serviço?
          </p>
          <ids-form-selection-group class="ids-pt-4" inline>
            <ids-form-selection class="ids-pt-2">
              <input
                type="radio"
                [value]="true"
                name="partner_additionalInformation_hasEmployee"
                formControlName="partner_additionalInformation_hasEmployee"
                idsRadioButton
              />
              <label>sim</label>
            </ids-form-selection>
            <ids-form-selection class="ids-pt-2">
              <input
                type="radio"
                [value]="false"
                name="partner_additionalInformation_hasEmployee"
                formControlName="partner_additionalInformation_hasEmployee"
                idsRadioButton
              />

              <label>não</label>
            </ids-form-selection>
          </ids-form-selection-group>
        </section>
        <section class="ids-col-12 " style="width: 100%">
          <section class="ids-col-12" style="width: 100%">
            <p class="ids-form ids-pb-4 ids-col-12">
              a venda deste imóvel será para um dos seus herdeiros legais?
            </p>
            <ids-form-selection-group class="ids-pt-4" inline>
              <ids-form-selection class="ids-pt-2">
                <input
                  type="radio"
                  [value]="true"
                  name="partner_additionalInformation_isSellingToFamily"
                  formControlName="partner_additionalInformation_isSellingToFamily"
                  idsRadioButton
                />
                <label>sim</label>
              </ids-form-selection>
              <ids-form-selection class="ids-pt-2">
                <input
                  type="radio"
                  [value]="false"
                  name="partner_additionalInformation_isSellingToFamily"
                  formControlName="partner_additionalInformation_isSellingToFamily"
                  idsRadioButton
                />

                <label>não</label>
              </ids-form-selection>
            </ids-form-selection-group>
          </section>
        </section>

        <section class="ids-col-12" style="width: 100%">
          <section class="ids-col-12" style="width: 100%">
            <p class="ids-col-12" style="width: 100%">
              você é menor de 18 anos, interdito (quem não responde por seus atos legalmente) ou tem
              imóvel como parte de um espólio ainda não partilhado?
            </p>
            <ids-form-selection-group class="ids-pt-4" inline>
              <ids-form-selection class="ids-pt-2">
                <input
                  type="radio"
                  [value]="true"
                  name="partner_additionalInformation_isUnderAge"
                  (change)="assetChange(true)"
                  formControlName="partner_additionalInformation_isUnderAge"
                  idsRadioButton
                />
                <label>sim</label>
              </ids-form-selection>
              <ids-form-selection class="ids-pt-2">
                <input
                  type="radio"
                  [value]="false"
                  name="partner_additionalInformation_isUnderAge"
                  (change)="assetChange(false)"
                  formControlName="partner_additionalInformation_isUnderAge"
                  idsRadioButton
                />
                <label>não</label>
              </ids-form-selection>
            </ids-form-selection-group>
          </section>
        </section>
      </section>

      <section class="ids-row">
        <section class="ids-col-6 " *ngIf="isAssets()">
          <p class="ids-col-6">especifique a situação </p>
          <ids-form-field class="ids-col-6" [errorMessage]="getErrorMandatory('espólio interdito')">
            <ids-select formControlName="partner_additionalInformation_situation" required>
              <ids-option
                *ngFor="let option of listaEspolio"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>
        </section>
      </section>


    </section>
  </form>
</section>
